import type { Achievement, Task } from '@/types'
import { apiClient } from './client'

export const getTasks = () =>
  apiClient.get<Task[]>('/tasks/').then((r) => r.data)

export const createTask = (data: Partial<Task>) =>
  apiClient.post<Task>('/tasks/', data).then((r) => r.data)

export const updateTask = (id: number, data: Partial<Task>) =>
  apiClient.patch<Task>(`/tasks/${id}/`, data).then((r) => r.data)

export const deleteTask = (id: number) =>
  apiClient.delete(`/tasks/${id}/`)

export const completeTask = (id: number) =>
  apiClient.post<Achievement>(`/tasks/${id}/complete/`).then((r) => r.data)
